import {Route, BrowserRouter, Switch} from 'react-router-dom';
import React        from 'react';
import ReactDOM     from 'react-dom';
import App          from './app/AppContainer';
import PageNotFound from './route/PageNotFound';
import Auth         from './route/Auth';
import Unauthorised from './route/Unauthorised';
import {locale}     from 'moment';

// Setup Global location
locale('pt');

ReactDOM.render((
    <BrowserRouter>
            <Switch>
                <Route exact path="/" component={App}/>
                <Route path="/auth" component={Auth}/>
                <Route path="/unauthorised" component={Unauthorised}/>
                <Route path="*" component={PageNotFound}/>
            </Switch>
    </BrowserRouter>
), document.getElementById('app-wrapper'));



// WEBPACK FOOTER //
// ./src/index.js